import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toPropertyKey from "@babel/runtime/helpers/toPropertyKey";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
export var PluginKeymap = /*#__PURE__*/function () {
  function PluginKeymap() {
    _classCallCheck(this, PluginKeymap);

    _defineProperty(this, "keymap", {});
  }

  _createClass(PluginKeymap, [{
    key: "bindKey",
    value: function bindKey(key, handler) {
      this.keymap = _objectSpread(_objectSpread({}, this.keymap), {}, _defineProperty({}, key, handler));
    }
  }, {
    key: "bindMultipleKeys",
    value: function bindMultipleKeys(keys, handler) {
      var _this = this;

      keys.forEach(function (key) {
        _this.keymap = _objectSpread(_objectSpread({}, _this.keymap), {}, _defineProperty({}, key, handler));
      });
    }
  }, {
    key: "unbindKey",
    value: function unbindKey(key) {
      var _this$keymap = this.keymap,
          keyToUnbind = _this$keymap[key],
          rest = _objectWithoutProperties(_this$keymap, [key].map(_toPropertyKey));

      this.keymap = rest;
    }
  }, {
    key: "getKeyBinding",
    value: function getKeyBinding(key) {
      return this.keymap[key];
    }
  }]);

  return PluginKeymap;
}();